// GET_CURRENCY
export const POST_ASSET_WITHDRAW = "POST_ASSET_WITHDRAW";
export const ASSET_WITHDRAW_SUCCESS = "ASSET_WITHDRAW_SUCCESS";
export const ASSET_WITHDRAW_FAILED = "ASSET_WITHDRAW_FAILED";


export const GET_WITHDRAW_HISTORY = "GET_WITHDRAW_HISTORY";
export const WITHDRAW_HISTORY_SUCCESS = "WITHDRAW_HISTORY_SUCCESS";
export const WITHDRAW_HISTORY_FAILED = "WITHDRAW_HISTORY_FAILED";

export const TRANSACTION_HISTORY = "TRANSACTION_HISTORY";
export const TRANSACTION_HISTORY_SUCCESS = "TRANSACTION_HISTORY_SUCCESS";
export const TRANSACTION_HISTORY_FAILED = "TRANSACTION_HISTORY_FAILED";

